/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Button, Grid, Modal, Input } from '../../../components/index';
import Masks from '../../../utils/masks';
import RemuneracaoControl from './RemuneracaoControl';
import {
  trataMensagensErro,
} from '../../../utils/requests';
import {
  tipoAfastamento,
  tipoTempoEspecial,
} from '../../../utils/listsSelect';
import { recuperarAnosQuePossuemAlgumaRemuneracao,
  DATA_INICIO_MOEDA_REAL,
  calcularTotal,
  validarDatasPeriodo,
  calcularTotalAfastamentos}
  from '../../../utils/ctcHelpers';

const VAZIO = '';
const ID_LISTA_ATIVIDADE = 1;
// afastamentos virou deducoes
const ID_LISTA_AFASTAMENTOS = 2;
const ID_LISTA_TEMPOS_CERTIFICADOS = 3;
const ID_LISTA_TEMPOS_ESPECIAIS = 4;
const ID_LISTA_REMUNERACOES = 5;
// const DATA_INICIO_MOEDA_REAL = '01/07/1994';

class ModalTemposERemuneracoes extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
  }

  getInitialState = () => ({
    touched: false,
    atividadeValida: false,
    qtdDiasContribuicaoLiquidoValido: false,
  });

  componentDidMount() {
    this.verificarAtividade();
  }

  verificaSeCampoDesabilitado = () => {
    const { acao } = { ...this.props.statePrincipal };
    if (acao === 'detalhar-ctc' || acao === 'detalhar-ctc-invalida') {
      return true;
    }
    return false;
  }

  checkIfCanBeSent = () => {
    const idAtividade = this.props.id;
    const { qtdDiasContribuicaoLiquidoValido } = { ...this.state };
    const { remuneracoesPreenchidas, atividade } = { ...this.props };
    const possuiDataInicio = (atividade && (atividade.dtInicio !== null && atividade.dtInicio !== '' && atividade.dtInicio.indexOf('_') === -1));
    const possuiDataFim = (atividade && (atividade.dtFim !== null && atividade.dtFim !== '' && atividade.dtFim.indexOf('_') === -1));
    let retornoOutrosCampos = false;
    let retornoCamposData = false;

    if (possuiDataInicio && possuiDataFim) {
      retornoCamposData = true;
    }
    switch (idAtividade) {
      case ID_LISTA_AFASTAMENTOS:
        if (this.props.atividade.tipo !== null) {
          retornoOutrosCampos = true;
        }
        break;
      case ID_LISTA_TEMPOS_CERTIFICADOS:
        if (this.props.atividade.indiceDestinatario !== null && qtdDiasContribuicaoLiquidoValido) {
          retornoOutrosCampos = true;
        }
        break;
      case ID_LISTA_TEMPOS_ESPECIAIS:
        if (this.props.atividade.tipo !== null) {
          retornoOutrosCampos = true;
        }
        break;
      case ID_LISTA_REMUNERACOES:
        if (remuneracoesPreenchidas.length > 0) {
          retornoOutrosCampos = true;
          retornoCamposData = true;
        }
        break;
      default:
        break;
    }
    return (retornoCamposData && retornoOutrosCampos);
  }

  montarComplementoTitulo = (id) => {
    const { dataInicioAtividadeMenorQue1994 } = { ...this.props.stateAtividade};
    const dataInicio = this.props.stateAtividade.ctcAtividade.dtInicio;

    let dataInicioFormat = moment(dataInicio, 'DD/MM/YYYY').format('DD/MM/YYYY');
    if(id === ID_LISTA_REMUNERACOES && dataInicioAtividadeMenorQue1994) {
      dataInicioFormat = DATA_INICIO_MOEDA_REAL;
    }
    const dataFim = this.props.stateAtividade.ctcAtividade.dtFim;
    const dataFimFormat = moment(dataFim, 'DD/MM/YYYY').format('DD/MM/YYYY');

    const complemento = `no período de ${dataInicioFormat} a ${dataFimFormat}`;
    return complemento;
  }

  verificarAtividade = () => {
    const { atividade } = { ...this.props };
    if (atividade && atividade.tempoLiquidoCertificado !== null && atividade.tempoLiquidoCertificado !== VAZIO) {
      this.setState({
        qtdDiasContribuicaoLiquidoValido: true,
      });
    }
  }

  atualizarLista = (lista) => {
    let { validadeCampos } = { ...this.props.stateAtividade };
    let { temposCertificados } = { ...this.props.stateAtividade.ctcAtividade };
    const idAtual = this.props.id;
    this.props.handleChangeCtcAtividade({ value: lista, isValid: lista.length > 0 }, this.props.determinarNomeListaAtividades());
    if (idAtual === ID_LISTA_TEMPOS_CERTIFICADOS) {
      this.props.gerenciarDestinacao(lista, 1);
      validadeCampos.temposCertificados = (temposCertificados.length > 0);
      this.props.handleChangeCtcAtividade({ value: validadeCampos, isValid: temposCertificados.length > 0 }, 'validadeCampos');
    }
    this.handleClose();
  }

  validarPeriodoTempoCertificado(tempo, diaQtdLiquido) {
    let retorno = false;
    if (tempo !== 0 && diaQtdLiquido <= tempo && diaQtdLiquido !== 0) {
      retorno = true;
    } else {
      trataMensagensErro(['O período é inválido. A quantidade de dias liquido deve ser maior que zero e menor que diferença entre a data de inicio e fim periodo.']);
    }
    this.setState({ qtdDiasContribuicaoLiquidoValido: retorno });
  }

  recuperarNomeDestinatario = (indice) => {
    let retorno = VAZIO;
    if (this.props.statePrincipal.destinacoesTempoCertificado) {
      const listaDestinacoesTempoCertificado = this.props.statePrincipal.destinacoesTempoCertificado;
      if (listaDestinacoesTempoCertificado !== undefined && listaDestinacoesTempoCertificado.length > 0) {
        const indiceNome = listaDestinacoesTempoCertificado.findIndex(d => (d.value === indice));
        if (indiceNome !== -1) {
          retorno = listaDestinacoesTempoCertificado[indiceNome].label;
        }
      }
    }
    return retorno;
  }

  formatarMoeda = (valor) => {
    if (typeof (valor) !== 'number') {
      let aux = valor;
      aux = valor.replace(/\./g, '').replace(/,/g, '.');
      return Number(aux);
    }
    return valor;
  }

  validarDataInicioEDataFimAtividade = (ativDtInicio, ativDtFim) => {
    let retorno = false;
    retorno = (!ativDtInicio.isSameOrBefore(ativDtFim));
    return retorno;
  }

  validarDataInicioAtividadeComPeriodoContribuicao = (ativDtInicio, periodoDtInicio, periodoDtFim) => {
    let retorno = false;
    retorno = (!ativDtInicio.isSameOrAfter(periodoDtInicio)) || (!ativDtInicio.isSameOrBefore(periodoDtFim));
    return retorno;
  }

  validarDataFimAtividadeComPeriodoContribuicao = (ativDtFim, periodoDtInicio, periodoDtFim) => {
    let retorno = false;
    retorno = (!ativDtFim.isSameOrAfter(periodoDtInicio)) || (!ativDtFim.isSameOrBefore(periodoDtFim));
    return retorno;
  }

  retornaMensagemValidacaoConcomitancia = (ativDtInicio, ativDtFim, periodoDtInicio, periodoDtFim, tituloAtividade, ctcAtividade) => {
    let retorno = '';
    if (this.validarDataInicioEDataFimAtividade(ativDtInicio, ativDtFim)) {
      retorno = `Data de Início ${this.props.atividade.dtInicio} deve ser anterior à data de fim do período ${tituloAtividade}.`;
    }

    if (this.validarDataInicioAtividadeComPeriodoContribuicao(ativDtInicio, periodoDtInicio, periodoDtFim)) {
      retorno = `Data de Início ${this.props.atividade.dtInicio} deve estar entre a data de início ${ctcAtividade.dtInicio}
      e fim do período ${ctcAtividade.dtFim} de atividade.`;
    }
    
    if (this.validarDataFimAtividadeComPeriodoContribuicao(ativDtFim, periodoDtInicio, periodoDtFim)) {
      retorno =`Data de Fim  ${this.props.atividade.dtFim} deve estar entre a data de início ${ctcAtividade.dtInicio}
      e fim do período ${ctcAtividade.dtFim} de atividade.`;
    }
    return retorno;
  }

  incluirDeducaoTempoCertificadoTempoEspecial = () => {
    const { atividade } = { ...this.props }; // atividade é a nova atividade que foi inserida via modal.
    const { ctcAtividade } = { ...this.props };
    const ativDtInicio = moment(atividade.dtInicio, 'DD/MM/YYYY');
    const ativDtFim = moment(atividade.dtFim, 'DD/MM/YYYY');
    const periodoDtInicio = moment(ctcAtividade.dtInicio, 'DD/MM/YYYY');
    const periodoDtFim = moment(ctcAtividade.dtFim, 'DD/MM/YYYY');
    const tituloAtividade = this.criarTituloModalPorAtividade();
    let lista = this.props.escolherLista(); // listas de afastamentos, temposCertificados, temposEspeciais, remuneracoes
    let mensagemDataInvalida = '';
    atividade.operacao = 1;

    if (atividade) {
      if (validarDatasPeriodo(ativDtInicio, ativDtFim, periodoDtInicio, periodoDtFim)) {
        if(!this.props.tratarConcomitancias(lista, atividade)) {
          atividade.nomeDestinacao = this.recuperarNomeDestinatario(atividade.indiceDestinatario);
          // if (lista.length === 0) {
            lista.push(atividade);
          // }
          this.atualizarLista(lista);
        } else {
          trataMensagensErro([`O período de ${atividade.dtInicio} até ${atividade.dtFim} é concomitante com outro período existente na lista.`]);
        }
      } else {
        mensagemDataInvalida = this.retornaMensagemValidacaoConcomitancia(ativDtInicio, ativDtFim, periodoDtInicio, periodoDtFim, tituloAtividade, ctcAtividade);
        trataMensagensErro([mensagemDataInvalida]);
        // trataMensagensErro([`A ação de ${tituloAtividade} do período de ${this.props.atividade.dtInicio} até 
        // ${this.props.atividade.dtFim} é inválida. ${mensagemDataInvalida} Verifique as datas digitadas.`]);
      }
    }
  }

  incluirRemuneracoes = () => {
    const { remuneracoesPreenchidas } = { ...this.props };
    const { remuneracoesAtividade } = { ...this.props.stateAtividade };
    let { remuneracoes } = { ...this.props.stateAtividade.ctcAtividade };
    // let { remuneracoesHistory } = { ...this.props};
    let aux = [];
    remuneracoesPreenchidas.forEach((remuneracao) => {
      const competencia = remuneracao.competencia.replace('-', '/');
      let mesCompetencia = null;
      let anoCompetencia = null;
      let siglaMoedaCompetencia = null;
      let valorRemuneracao = null;
      let tipoMoedaCompetencia = null;

      const index = remuneracoesAtividade.moedasCompetencia.findIndex(r => (r.competencia === competencia));
      if (index !== -1) {
        mesCompetencia = parseInt(remuneracoesAtividade.moedasCompetencia[index].competencia.substring(0, 2), 10);
        anoCompetencia = parseInt(remuneracoesAtividade.moedasCompetencia[index].competencia.substring(3, 7), 10);
        siglaMoedaCompetencia = remuneracoesAtividade.moedasCompetencia[index].sigla;
        valorRemuneracao = this.formatarMoeda(remuneracao.valor);
        tipoMoedaCompetencia = remuneracoesAtividade.moedasCompetencia[index].tipoMoeda;

        if (remuneracoes === null) {
          remuneracoes = [];
        }

        const indiceRemuneracao = remuneracoes.findIndex(r => (r.mes === mesCompetencia && r.ano === anoCompetencia));
        if (indiceRemuneracao === -1) {
          const ctcAtividadeRemuneracao = {
            mes: mesCompetencia,
            ano: anoCompetencia,
            tipoMoeda: tipoMoedaCompetencia,
            siglaMoeda: siglaMoedaCompetencia,
            valor: valorRemuneracao,
          };
          remuneracoes.push(ctcAtividadeRemuneracao);
        }

        const indiceAno = aux.findIndex(a => (a.ano === anoCompetencia));
        if (indiceAno === -1) {
          const ano = {
            ano: anoCompetencia,
          }
          aux.push(ano);
        }
      }
    });

    aux = recuperarAnosQuePossuemAlgumaRemuneracao(aux, remuneracoes);

    this.props.handleChange({ value: !this.props.showModal, isValid: true }, 'showModal');
    this.props.handleChangeCtcAtividade({ value: remuneracoes, isValid: remuneracoes.length > 0 }, 'remuneracoes');
    this.props.handleChangeCtcAtividade({ value: aux, isValid: aux.length > 0 }, 'anosQuePossuemAlgumaRemuneracao');
    // this.props.handleChange({ value: remuneracoesHistory, isValid: remuneracoesHistory.length > 0 }, 'remuneracoesHistory');
  }

  alterarDeducaoTempoCertificadoTempoEspecial = () => {
    const { atividade } = { ...this.props };
    const { ctcAtividade } = { ...this.props };
    const ativDtInicio = moment(atividade.dtInicio, 'DD/MM/YYYY');
    const ativDtFim = moment(atividade.dtFim, 'DD/MM/YYYY');
    const periodoDtInicio = moment(ctcAtividade.dtInicio, 'DD/MM/YYYY');
    const periodoDtFim = moment(ctcAtividade.dtFim, 'DD/MM/YYYY');
    const tituloAtividade = this.criarTituloModalPorAtividade();

    let lista = this.props.escolherLista();
    let mensagemDataInvalida = '';
    atividade.operacao = 2;

    if (atividade) {
      let listaAux = lista[atividade.indice];
      lista[atividade.indice] = atividade;
      if (validarDatasPeriodo(ativDtInicio, ativDtFim, periodoDtInicio, periodoDtFim)) {
        if(!this.props.tratarConcomitancias(lista, atividade)) {
          atividade.nomeDestinacao = this.recuperarNomeDestinatario(atividade.indiceDestinatario);
          lista = this.props.ordenarLista(lista);
          const index = lista.findIndex(a => (a.indice === atividade.indice));
            if (index !== -1) {
              if (lista[index].dtInicio !== atividade.dtInicio) {
                lista[index].dtInicio = atividade.dtInicio;
              }
              if (lista[index].dataFim !== atividade.dtFim) {
                lista[index].dataFim = atividade.dtFim;
              }
              if (atividade.idAtividade) {
                lista[index].operacao = atividade.operacao;
              } else {
                lista[index].operacao = 1;
              }
            }
            this.atualizarLista(lista);
        } else {
          lista[atividade.indice] = listaAux;
          trataMensagensErro([`O período de ${atividade.dtInicio} até ${atividade.dtFim} é concomitante com outro período existente na lista.`]);
        }
      } else {
        lista[atividade.indice] = listaAux;
        mensagemDataInvalida = this.retornaMensagemValidacaoConcomitancia(ativDtInicio, ativDtFim, periodoDtInicio, periodoDtFim, tituloAtividade, ctcAtividade);
        trataMensagensErro([mensagemDataInvalida]);
        // trataMensagensErro([`A ação de ${tituloAtividade} do período de ${this.props.atividade.dtInicio} até 
        // ${this.props.atividade.dtFim} é inválida. ${dtInvalida} Verifique as datas digitadas.`]);
      }
    }
  }

  alterarRemuneracoes = () => {
    let { remuneracoesPreenchidas } = { ...this.props };
    let { remuneracoesHistory } = { ...this.props };
    const { remuneracoesAtividade } = { ...this.props.stateAtividade };
    let { remuneracoes } = { ...this.props.stateAtividade.ctcAtividade };
    let { anosQuePossuemAlgumaRemuneracao } = { ...this.props.stateAtividade };

    // limpar a coleção de remunerações
    remuneracoes = remuneracoes.splice();
    this.props.handleChangeCtcAtividade({ value: remuneracoes, isValid: remuneracoes.length > 0 }, 'remuneracoes');
    this.props.ordenarLista(remuneracoesPreenchidas);
    remuneracoesPreenchidas.forEach((remuneracao) => {
      const competencia = remuneracao.competencia.replace('-', '/');
      let mesCompetencia = null;
      let anoCompetencia = null;
      let siglaMoedaCompetencia = null;
      let valorRemuneracao = null;
      let tipoMoedaCompetencia = null;
      const index = remuneracoesAtividade.moedasCompetencia.findIndex(r => (r.competencia === competencia));
      if (index !== -1) {
        mesCompetencia = parseInt(remuneracoesAtividade.moedasCompetencia[index].competencia.substring(0, 2), 10);
        anoCompetencia = parseInt(remuneracoesAtividade.moedasCompetencia[index].competencia.substring(3, 7), 10);
        siglaMoedaCompetencia = remuneracoesAtividade.moedasCompetencia[index].sigla;
        tipoMoedaCompetencia = remuneracoesAtividade.moedasCompetencia[index].tipoMoeda;
        valorRemuneracao = this.formatarMoeda(remuneracao.valor);

        const ctcAtividadeRemuneracao = {
          mes: mesCompetencia,
          ano: anoCompetencia,
          tipoMoeda: tipoMoedaCompetencia,
          siglaMoeda: siglaMoedaCompetencia,
          valor: valorRemuneracao,
        };
        remuneracoes.push(ctcAtividadeRemuneracao);

        const indiceAno = anosQuePossuemAlgumaRemuneracao.findIndex(a => (a.ano === anoCompetencia));
        if (indiceAno === -1) {
          const ano = {
            ano: anoCompetencia,
          }
          anosQuePossuemAlgumaRemuneracao.push(ano);
        }
      }
    });

    anosQuePossuemAlgumaRemuneracao = recuperarAnosQuePossuemAlgumaRemuneracao(anosQuePossuemAlgumaRemuneracao, remuneracoes);
    let aux = [];

    anosQuePossuemAlgumaRemuneracao.forEach((anoQuePossuiAlgumaRemuneracao) => {
      const indiceAno = anosQuePossuemAlgumaRemuneracao.findIndex(a => (a.ano === anoQuePossuiAlgumaRemuneracao));
      if (indiceAno === -1) {
        aux.push(anoQuePossuiAlgumaRemuneracao);
      }
    });
    if (aux.length > 0) {
      this.props.handleChangeCtcAtividade({ value: aux, isValid: true }, 'anosQuePossuemAlgumaRemuneracao');
    }
    remuneracoesHistory = [];
    remuneracoesPreenchidas.forEach(remuneracaoPreenchida => {
      remuneracoesHistory.push(remuneracaoPreenchida);
    });

    this.props.handleChange({ value: !this.props.showModal, isValid: true }, 'showModal');
    this.props.handleChange({ value: null, isValid: true }, 'operacaoRemuneracao');
    this.props.handleChangeCtcAtividade({ value: remuneracoes, isValid: remuneracoes.length > 0 }, 'remuneracoes');
    this.props.handleChange({ value: remuneracoesHistory, isValid: remuneracoesHistory.length > 0 }, 'remuneracoesHistory');
  }

  handleAdicionarAtividade = () => {
    const idAtividade = this.props.id;
    const incluirRemuneracao = (idAtividade && idAtividade === 5);

    if (incluirRemuneracao) {
      this.incluirRemuneracoes();
    } else {
      this.incluirDeducaoTempoCertificadoTempoEspecial();
    }
  }

  handleAlterarAtividade = () => {
    const idAtividade = this.props.id;
    const alterarRemuneracao = (idAtividade && idAtividade === 5);

    if (alterarRemuneracao) {
      this.alterarRemuneracoes();
    } else {
      this.alterarDeducaoTempoCertificadoTempoEspecial();
    }
  }

  criarTituloModalPorAtividade = () => {
    const { atividade } = { ...this.props };
    const idAtividade = this.props.id;
    let tituloOperacao = 'incluir';
    let retorno = VAZIO;

    if (idAtividade === ID_LISTA_REMUNERACOES) {
      const { operacaoRemuneracao } = { ...this.props };
      if (operacaoRemuneracao === 2) {
        tituloOperacao = 'atualizar';
      }
      // }
    } else if (idAtividade !== ID_LISTA_REMUNERACOES && (atividade && (atividade.operacao && atividade.operacao === 2))) {
      tituloOperacao = 'alterar';
    }

    switch (idAtividade) {
      case ID_LISTA_AFASTAMENTOS:
        retorno = `${tituloOperacao} dedução ${this.montarComplementoTitulo(idAtividade)}`;
        break;
      case ID_LISTA_TEMPOS_CERTIFICADOS:
        retorno = `${tituloOperacao} tempo certificado ${this.montarComplementoTitulo(idAtividade)}`;
        break;
      case ID_LISTA_TEMPOS_ESPECIAIS:
        retorno = `${tituloOperacao} tempo especial ${this.montarComplementoTitulo(idAtividade)}`;
        break;
      case ID_LISTA_REMUNERACOES:
        retorno = `${tituloOperacao} remunerações ${this.montarComplementoTitulo(idAtividade)}`;
        break;
      default:
        break;
    }
    return retorno;
  }

  criarTituloBotaoPorAtividade = () => {
    const { atividade } = { ...this.props };
    const idAtividade = this.props.id;
    let tituloOperacao = 'adicionar';

    if (idAtividade === ID_LISTA_REMUNERACOES) {
      const { operacaoRemuneracao } = { ...this.props };
      if (operacaoRemuneracao === 2) {
        tituloOperacao = 'atualizar';
      }
    } else if (idAtividade !== ID_LISTA_REMUNERACOES && (atividade && (atividade.operacao && atividade.operacao === 2))) {
      tituloOperacao = 'alterar';
    }
    return `${tituloOperacao}`;
  }
  
  direcionarAtividadeManter = () => {
    const { atividade } = { ...this.props };
    const idAtividade = this.props.id;
    let callback = this.handleAdicionarAtividade;

    if (idAtividade === ID_LISTA_REMUNERACOES) {
      const { operacaoRemuneracao } = { ...this.props };
      if (operacaoRemuneracao === 2) {
        callback = this.handleAlterarAtividade;
      }
    } else if (idAtividade !== ID_LISTA_REMUNERACOES && (atividade && (atividade.operacao && atividade.operacao === 2))) {
      callback = this.handleAlterarAtividade;
    }
    return callback;
  }
  // /*
  //   Apresentar o tempo líquido em dias, calculado da seguinte forma: 
  //   quantidade de dias corridos entre a data fim e a data de início de tempos certificados inclusive,
  //   menos a quantidade de dias de afastamento.
  // */
  // //| dataInicio  afastamento.dtInicio  afastamento.dtFim  dataFim |
  calcularDeducoes = (dataInicio, dataFim, id) => {
    let total = 0;
    let totalAfastamentos = 0;
    let retorno = '';
    let { afastamentos } = { ...this.props.ctcAtividade };
    if (afastamentos === null) {
      afastamentos = [];
    }

    if ((dataInicio !== undefined && dataInicio !== null && dataInicio !== '' && dataInicio.indexOf('_') === -1) &&
      (dataFim !== undefined && dataFim !== null && dataFim !== '' && dataFim.indexOf('_') === -1)) {
        if(id === ID_LISTA_TEMPOS_CERTIFICADOS) {
          totalAfastamentos = calcularTotalAfastamentos(dataInicio, dataFim, afastamentos);
          total = calcularTotal(dataInicio, dataFim);
        } 
        const inicio = moment(dataInicio, 'DD/MM/YYYY').toDate();
        const fim = moment(dataFim, 'DD/MM/YYYY').toDate();
        total = (moment(fim).diff(inicio, 'days') + 1);
        
        retorno = {value: (total - totalAfastamentos)};
  
        //this.props.handleChange(retorno, 'tempoLiquidoCertificado');
  
        this.setState({ qtdDiasContribuicaoLiquidoValido: true });
    }
    this.props.handleChange(retorno, 'tempoLiquidoCertificado');
  }

  verificarDatas = () => {
    const {dtInicio} = { ...this.props.atividade} ;
    const {dtFim} = { ...this.props.atividade };
    let retorno = true;
    if ((dtInicio !== null && dtInicio !== '') && (dtFim !== null && dtFim !== '')) {
      return false;
    }
    return retorno;
  }

  defineTamanhoColuna = (id) => {
    let retorno = '3 3 3 3';
    // if (id === 3) {
    if ([ID_LISTA_AFASTAMENTOS, ID_LISTA_TEMPOS_CERTIFICADOS, ID_LISTA_TEMPOS_ESPECIAIS].includes(id)) {
      retorno = '4 4 4 4';
    }
    return retorno;
  }

  existeObjeto = (objeto) => {
    if (objeto !== undefined && objeto !== null && objeto !== '' ) {
      return true;
    }
    return false;
  }

  validarDiasContribuicaoLiquidoTempoCertificado = () => {
    const { atividade } = { ...this.props };
    if (atividade) {
      if ((atividade.dtInicio && (atividade.dtInicio !== VAZIO && atividade.dtInicio.indexOf('_') === -1)) &&
        (atividade.dtFim && (atividade.dtFim !== VAZIO && atividade.dtFim.indexOf('_') === -1)) &&
        (atividade.tempoLiquidoCertificado !== null && atividade.tempoLiquidoCertificado !== VAZIO && atividade.tempoLiquidoCertificado !== '0')) {
        const data1 = moment(atividade.dtInicio, 'DD/MM/YYYY');
        const data2 = moment(atividade.dtFim, 'DD/MM/YYYY');
        const diferenca = data2.diff(data1, 'days');
        const qtdDiasContribuicaoLiquido = (Number(diferenca) + 1);
        if (this.existeObjeto(atividade.tempoLiquidoCertificado)) {
          this.validarPeriodoTempoCertificado(qtdDiasContribuicaoLiquido, atividade.tempoLiquidoCertificado);
        }
      } else {
        trataMensagensErro(['O prenchimento do tempo líquido é obrigatório.']);
        this.setState({ qtdDiasContribuicaoLiquidoValido: false });
      }
    }
  }


  modalFooter = () => (
    <React.Fragment>
      {(!['detalhar-ctc', 'detalhar-ctc-invalida'].includes(this.props.statePrincipal.acao)) &&
        <div className="right">
          <Button
            className="reajustaDireitaBotao"
            disabled={!this.checkIfCanBeSent()}
            hint={this.criarTituloBotaoPorAtividade()}
            onClick={this.direcionarAtividadeManter()}
            title={this.criarTituloBotaoPorAtividade()}
          />
          <Button
            className="reajustaDireitaBotao"
            title="cancelar"
            onClick={this.handleClose}
            hint="cancelar"
          />
        </div>
      }
    </React.Fragment>
  )

  modalContent = () => (
    <React.Fragment>
      <div className="row">
      {this.props.id === 2 &&
          <div>
            <Grid cols="12 12 12 12">
              <Input
                label="Tipo da dedução"
                onChange={e => this.props.handleChange(e, 'tipo')}
                value={this.props.atividade.tipo}
                itemList={tipoAfastamento}
                disabled={this.verificaSeCampoDesabilitado()}
                required
              />
            </Grid>
          </div>
        }
        {this.props.id === 4 &&
          <div>
            <Grid cols="12 12 12 12">
              <Input
                label="Tipo do Tempo Especial"
                onChange={e => this.props.handleChange(e, 'tipo')}
                value={this.props.atividade.tipo}
                itemList={tipoTempoEspecial}
                disabled={this.verificaSeCampoDesabilitado()}
                required
              />
            </Grid>
          </div>
        }
        {this.props.id === 3 &&
          <div>
            <Grid cols="12 12 12 12">
              <Input
                label="Destinatário"
                onChange={e => this.props.handleChange(e, 'indiceDestinatario')}
                value={this.props.atividade.indiceDestinatario}
                itemList={this.props.statePrincipal.destinacoesTempoCertificado}
                disabled={this.verificaSeCampoDesabilitado()}
                placeholder="Selecione a opção"
                required
              />
            </Grid>
          </div>
        }
        {![ID_LISTA_ATIVIDADE, ID_LISTA_REMUNERACOES].includes(this.props.id) &&
          <div>
            <Grid cols={this.defineTamanhoColuna(this.props.id)}>
              <Input
                label="Data de Início"
                onChange={e => this.props.handleChange(e, 'dtInicio')}
                value={this.props.atividade.dtInicio}
                mask={Masks.date}
                disabled={this.verificaSeCampoDesabilitado()}
                required
                onBlur={(this.props.statePrincipal.ctc.tipoCtc === null || this.props.statePrincipal.ctc.tipoCtc === 1) ?
                  (e => this.calcularDeducoes(this.props.atividade.dtInicio, this.props.atividade.dtFim, this.props.id)) :
                  ''}
              />
            </Grid>
            <Grid cols={this.defineTamanhoColuna(this.props.id)}>
              <Input
                label="Data de Término"
                onChange={e => this.props.handleChange(e, 'dtFim')}
                value={this.props.atividade.dtFim}
                mask={Masks.date}
                disabled={this.verificaSeCampoDesabilitado()}
                required
                onBlur={(this.props.statePrincipal.ctc.tipoCtc === null || this.props.statePrincipal.ctc.tipoCtc === 1) ?
                  (e => this.calcularDeducoes(this.props.atividade.dtInicio, this.props.atividade.dtFim, this.props.id)) :
                  ''}
              />
            </Grid>
            {([ID_LISTA_AFASTAMENTOS, ID_LISTA_TEMPOS_CERTIFICADOS, ID_LISTA_TEMPOS_ESPECIAIS].includes(this.props.id)) &&
            (this.props.statePrincipal.ctc.tipoCtc === null || this.props.statePrincipal.ctc.tipoCtc === 1) ?
              <Grid cols="4 4 4 4">
                <Input
                  label="Tempo Líquido"
                  maxlength="5"
                  onChange={e => this.props.handleChange(e, 'tempoLiquidoCertificado')}
                  value={this.props.atividade.tempoLiquidoCertificado}
                  readOnly
                  integer
                  number
                />
              </Grid>
            :
            <Grid cols="4 4 4 4">
              <Input
                label="Tempo Líquido"
                maxlength="5"
                onChange={e => this.props.handleChange(e, 'tempoLiquidoCertificado')}
                onBlur={e => this.validarDiasContribuicaoLiquidoTempoCertificado()}
                value={this.props.atividade.tempoLiquidoCertificado}
                integer
                number
                exibirBotao
                onClickDoBotao={() => this.calcularDeducoes(this.props.atividade.dtInicio, this.props.atividade.dtFim)}
                hintDoBotao="Calcular o tempo líquido"
                iconeDoBotao="ico-doc-magnifier"
                disabledBotao={this.verificarDatas()}
                classe="dtp-primary"
              />
              </Grid>
            }
          </div>
        }
        {this.props.id === ID_LISTA_REMUNERACOES &&
          <div style={{ height: '470px', width: '1200px', 'overflow-y': 'auto', 'overflow-x': 'auto'}}>
            <RemuneracaoControl
              remuneracoesAtividade={this.props.stateAtividade.remuneracoesAtividade}
              handleChange={this.props.handleChange}
              atualizarListaRemuneracao={this.props.atualizarListaRemuneracao}
              remuneracoesPreenchidas={this.props.remuneracoesPreenchidas}
              preencherColecaoAutomaticamente={this.props.preencherColecaoAutomaticamente}
              desabilitarCampos={(this.props.statePrincipal.acao === 'detalhar-ctc' ||
              this.props.statePrincipal.acao === 'detalhar-ctc-invalida')}
              operacaoRemuneracao={this.props.operacaoRemuneracao}
              anoEscolhido={this.props.anoEscolhido}
              acao={this.props.statePrincipal.acao}
            />
          </div>
        }
      </div>
    </React.Fragment>
  )
  handleClose = () => {
    this.setState(this.props.resetAtividades);
  }

  render() {
    return (
      <Modal
        {...this.props}
        backdrop="static"
        keyboard={false}
        id='modalTemposERemuneracoes'
        conteudofooter={this.modalFooter()}
        conteudomodal={this.modalContent()}
        onHide={this.handleClose}
        size="1500px"
        showModal={this.props.showModal}
        title={this.criarTituloModalPorAtividade()}
      />
    );
  }
}

ModalTemposERemuneracoes.propTypes = {
  id: PropTypes.string.isRequired,
  atividade: PropTypes.objectOf(PropTypes.object),
  showModal: PropTypes.func,
  ctcAtividade: PropTypes.objectOf(PropTypes.object),
  determinarConcomitancias: PropTypes.func,
  ordenarLista: PropTypes.func,
  resetAtividades: PropTypes.func,
  determinarNomeListaAtividades: PropTypes.func,
  verificarListaInclusao: PropTypes.func,
  gerenciarDestinacao: PropTypes.func,
  validarDiasContribuicaoLiquido: PropTypes.func,
  validarPeriodoTempoCertificado: PropTypes.func,
  tratarConcomitancias: PropTypes.func,
  statePrincipal: PropTypes.objectOf(PropTypes.object),
  stateAtividade: PropTypes.objectOf(PropTypes.object),
  atualizarListaRemuneracao: PropTypes.func,
  anoEscolhido: PropTypes.number,
  remuneracoesPreenchidas: PropTypes.arrayOf(PropTypes.shape({
    competencia: PropTypes.string,
    valor: PropTypes.string,
  })),
  remuneracoesHistory: PropTypes.arrayOf(PropTypes.shape({
    competencia: PropTypes.string,
    valor: PropTypes.string,
  })),
  operacaoRemuneracao: PropTypes.number,
  handleChange: PropTypes.func,
  handleChangeCtcAtividade: PropTypes.func,
  preencherColecaoAutomaticamente: PropTypes.func,
  escolherLista: PropTypes.func,
}.isRequired;

export default ModalTemposERemuneracoes;



// WEBPACK FOOTER //
// ./src/pages/repositorio-ctc/templates/ModalTemposERemuneracoes.jsx